

import {
	database, SettingKey,
} from 'utils/database';
import {
	useBasisService,
} from 'services';
import {
	Settings,
} from 'models';


/**
 * A service for managing locally stored user preferences
 */
export const useSettingsService = () => {
	const {
		data,
		table,
	} = useBasisService<Settings>(
		database.settings,
		(t) => t.toArray().then(list => {
			const settings: Settings = {
			};
			list.forEach(
				setting =>
				/**
				 * Ignoring this, because there should never be the wrong type.
				 * @param setting
				 */
				// @ts-ignore
					settings[setting.key] = setting.value
			)
			return settings;
		})
	);

	const patch = (key: SettingKey, value: any) => table.put({
		key, value,
	});

	return {
		database,
		data,
		patch,
	};
};